import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useParams } from 'react-router';
import { CustomInput, Modal, NoResult, Text } from '../../..';
import { withMediaQueries } from '../../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../../style';
import { MODAL_CLOSE } from '../../../../../app/redux/actions';
import Pagination from '../../../Pagination';
import SortBy from '../../../SortBy';
import { FiltersWrapper, Legend, SortingWrapper, LogCard } from './style';
import { LOGS_LIST_GET } from '../../../../../app/redux/actions/supervisorStats';
import TimeIntervalFilter from '../../../TimeIntervalFilter';
import { timestampToDate } from '../../../../../utils/common';
import theme from '../../../../theme';

export const ModalSupervisorUserLogId = 'ModalSupervisorUserLog';

const ModalSupervisorUserLog = ({
  mediaIsPhone,
  user,
  list,
  filters,
  pager,
  getLogsList,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);

  const { user_id } = useParams();

  // filters
  const [selectedFilters, setSelectedFilters] = useState({
    user_id,
    table: -1,
  });
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    getLogsList(selectedFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetLogsList = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      page,
    };
    getLogsList(parsedFilters);
  };

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) handleGetLogsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetLogsList(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <Modal
      title="Dettaglio log:"
      subTitle={`${user?.first_name} ${user?.last_name}`}
      description="Sezione dedicata alla visualizzazione di tutte le azioni compiute all’interno della piattaforma dall’utente selezionato."
      modalId={ModalSupervisorUserLogId}
      scrollableAreaRef={scrollableAreaRef}
      mbTitle={8}
      mbSubTitle={16}
      mbDescription={32}
      className="max-size"
    >
      <FiltersWrapper>
        <CustomInput
          size={496}
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value=""
          icon="search-sm"
          isClearable
          onChange={(v) => setSearchValue(v)}
          onClickIcon={onClickSearch}
          onKeyPress={(event) => {
            if (event.key === 'Enter') onClickSearch();
          }}
        />
        <TimeIntervalFilter
          callback={(start_date, end_date) => {
            setSelectedFilters({
              ...selectedFilters,
              start_date,
              end_date,
            });
          }}
        />
      </FiltersWrapper>
      <SortingWrapper>
        <Text type="b3">{pager?.total_items || 0} log</Text>
        <SortBy
          options={[
            { label: 'Dal più recente', value: 'created_desc' },
            { label: 'Dal meno recente', value: 'created_asc' },
          ]}
          onChange={(v) => {
            setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
          }}
        />
      </SortingWrapper>
      <Legend>
        <Text type="statistics-heading">Descrizione log</Text>
        <Text type="statistics-heading">Indirizzo IP</Text>
        <Text type="statistics-heading">Data e ora</Text>
      </Legend>
      <ScrollableArea ref={scrollableAreaRef} preserveShadows>
        {list?.length > 0 ? (
          (list || []).map((log, i) => (
            <LogCard key={`log-${i}`}>
              <Text type="h3">{log?.description}</Text>
              <Text type="b4" color={theme().colors.primaryDarkGray700}>
                {log?.user_client_ip}
              </Text>
              <Text type="b4" color={theme().colors.primaryDarkGray700}>
                {timestampToDate(log?.created, 'DD/MM/YYYY - HH:mm')}
              </Text>
            </LogCard>
          ))
        ) : (
          <NoResult />
        )}
      </ScrollableArea>
      <Footer pt={40} pb={43}>
        <Pagination
          pb={0}
          pager={pager}
          callBack={loadMore}
          setItemsPerPage={setItemsPerPage}
        />
      </Footer>
    </Modal>
  );
};

ModalSupervisorUserLog.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  user: PropTypes.object,
  list: PropTypes.array,
  filters: PropTypes.object,
  pager: PropTypes.object,
  // dispatch
  getLogsList: PropTypes.func.isRequired,
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { user } = state.statistics;
      const { list, filters, pager } = state.supervisorStats.lists.logs;
      return { user, list, filters, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getLogsList: (filters) =>
        dispatch({ type: LOGS_LIST_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalSupervisorUserLog);
